import { RadioDesc, RadioOption, RadioTitle } from '../../../shared/styles/components/forms.styles';

import React from 'react';

interface ScopeCheckboxProps {
    id: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    title: string;
    description: string;
    disabled?: boolean;
}

export const ScopeCheckbox: React.FC<ScopeCheckboxProps> = ({
    id,
    checked,
    onChange,
    title,
    description,
    disabled = false
}) => (
    <RadioOption $disabled={disabled}>
        <input
            type="checkbox"
            id={id}
            checked={checked}
            disabled={disabled}
            onChange={(e) => onChange(e.target.checked)}
        />
        <label htmlFor={id}>
            <RadioTitle>{title}</RadioTitle>
            <RadioDesc>{description}</RadioDesc>
        </label>
    </RadioOption>
);